var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('loader'):_c('div',[(_vm.promotion && _vm.isPromotionEligible)?_c('welcome-with-promo'):_c('welcome',{attrs:{"referralData":_vm.referralData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }